import React from 'react';
import { useRecoilValue } from 'recoil';
import { userValue } from '../../store/userState';
import styles from "./KeywordsRemaining.module.scss";

const KeywordsRemaining = () => {

    const {
        creditBudget,
        availableCredits
    } = useRecoilValue(userValue);

    // console.log(keywordsLimit, availableCredits);

    return(
        <div className={styles.KeywordsRemaining}>
            <h6 className={styles.Main}>
                {availableCredits} / {creditBudget}
            </h6>
            <p className={styles.detail}>
                zbývá klíčových slov
            </p>
        </div>
    );
  }
  export default KeywordsRemaining;